var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { WorkSpaceUserStorageType } from '../../UtilsClasses/WorkSpaceUserKey';
import { UserWebStorageInstance } from '../../../user-web-storage';
import { DataBaseWorkingClass } from '../../DataBase/old/DataBaseWorkingClass';
import { UserManager } from '@shared/utils/Managers/UserManager';
class _TvWorkspaceProvider {
    constructor() {
        this.dbName = 'TvDb';
        this.tableName = 'TvWorkSpaces';
        this.userStorageKey = 'id';
        this.indexedDBProvider = new DataBaseWorkingClass(this.dbName);
    }
    reinitDatabase() {
        return __awaiter(this, void 0, void 0, function* () {
            this.indexedDBProvider.CloseDB();
        });
    }
    getWorkSpace() {
        return __awaiter(this, void 0, void 0, function* () {
            let localTime = 0;
            yield this.openLocalDataBase();
            const request = yield this.indexedDBProvider.GetFromDB(this.hash, this.tableName);
            const localData = request.result;
            if (!isNullOrUndefined(localData)) {
                localTime = localData.time;
            }
            let serverTime = 0;
            let serverData = null;
            try {
                const serverResponse = yield UserWebStorageInstance.tvWorkspaces.get(this.hash);
                serverData = serverResponse === null || serverResponse === void 0 ? void 0 : serverResponse.data;
                if (!isNullOrUndefined(serverData)) {
                    serverTime = serverData.time;
                }
            }
            catch (e) {
                console.warn('Error getting workspace from server storage', e);
            }
            if (localTime === 0 && serverTime === 0) {
                return null;
            }
            if (localTime > serverTime) {
                return localData;
            }
            return serverData;
        });
    }
    saveWorkSpaceOnServer(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield UserWebStorageInstance.tvWorkspaces.put(this.hash, data);
            }
            catch (e) {
                console.error('Error saving workspace to server storage', e);
            }
        });
    }
    saveWorkSpaceToIndexedDb(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.openLocalDataBase();
                data.id = this.hash;
                yield this.indexedDBProvider.AddToDB(data, this.tableName);
            }
            catch (e) {
                console.error('Error saving workspace to local storage', e);
            }
        });
    }
    openLocalDataBase() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hash = UserManager.getWorkSpaceKey(WorkSpaceUserStorageType.TVTradingPlatform);
            if (this.indexedDBProvider.IsOpened())
                return;
            yield this.indexedDBProvider.OpenDB(this.tableName, this.userStorageKey);
        });
    }
}
export const TvWorkspaceProvider = new _TvWorkspaceProvider();
